<script>
  // Renders a value as a state badge. A column either names a shared domain from
  // lib/ui/badges.js, or carries its own inline map (so per-entity states don't need
  // a shared-file edit):
  //   { slot:'status', field:'state', renderer:'state_badge', domain:'submission' }
  //   { slot:'status', field:'kind', renderer:'state_badge',
  //     badges: { ad:{label:'Ad',badgeClass:'badge-info'}, promo:{label:'Promo',badgeClass:'badge-accent'} } }
  // Optional per-row text: `labelField` overrides the mapped label (the value still picks
  // the color), `tooltipField` adds a hover detail. Both are dot-paths on the row.
  import { badgeFor } from '../../../lib/ui/badges.js'
  import { resolveField } from '../../../lib/entities/slots.js'

  let { value, row = {}, column = {} } = $props()
  const badge = $derived(column.badges?.[String(value)] ?? badgeFor(column.domain, value))
  const label = $derived((column.labelField && resolveField(row, column.labelField)) || badge.label)
  const tooltip = $derived(column.tooltipField ? resolveField(row, column.tooltipField) : null)
</script>

{#if value != null && value !== ''}
  {#if tooltip}
    <span class="tooltip" data-tip={tooltip}>
      <span class="badge badge-sm whitespace-nowrap {badge.badgeClass}">{label}</span>
    </span>
  {:else}
    <span class="badge badge-sm whitespace-nowrap {badge.badgeClass}">{label}</span>
  {/if}
{:else}
  <span class="text-base-content/40">—</span>
{/if}
